import React, { FC, useState } from "react";
import {
  UI_ModuleTextDownCard,
  UI_ModuleTitleCard,
} from "../../../../../../UI_ITO/indexUI";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { IndividualCardInfo } from "./IndividualCardInfo/IndividualCardInfo";
import { MemberFL } from "../../../../../../store/types/applicationBank.type";

interface IndividualCardProps {
  individual: MemberFL;
}

export const IndividualCard: FC<IndividualCardProps> = ({ individual }) => {
  const { inn, name, is_eio } = individual;
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);

  return (
    <div>
      <UI_ModuleTitleCard
        title={`${name}` + (is_eio ? " (Является ЕИО)" : "")}
        textDown={<UI_ModuleTextDownCard textDown={[`ИНН ${inn}`]} />}
        style={{ width: "100%" }}
        icon={collapseIsOpen ? <UpOutlined /> : <DownOutlined />}
        onClick={() => setCollapseIsOpen((prev) => !prev)}
      />
      {collapseIsOpen && <IndividualCardInfo individual={{ ...individual }} />}
    </div>
  );
};
